export default {
	'THEME': 'butcher',
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_CHILDPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_ORDERBOX_DELIVERY": false,
	"FEATURE_ORDERBOX_TAKEAWAY": false,
	"FEATURE_RESERVATION": false,
}
